'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  z-index: 30;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  transform: initial;
  i {
    color: ${theme.colors.primary[1]};
  }
`;
